import moment from 'moment';
import get from 'lodash.get';
import uniq from 'lodash.uniq';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { AppState } from 'services/types';
import { SprayEventUuid } from 'services/sprayEvents/types';
import { selectSprayEvents } from 'services/sprayEvents/selectors';
import { OwnProps } from './index';
import { makeSelectSelectedIncompleteSprayEventsUuids } from '../../../SprayEventsVirtualizedTable/selectors';

const selectSprayEventsUuids = (
    state: AppState,
    props: OwnProps
): SprayEventUuid[] => props.uuids;

const selectSelectedSprayEventsDates = createDeepEqualSelector(
    selectSprayEvents,
    makeSelectSelectedIncompleteSprayEventsUuids(),
    (sprayEvents, incompletedSprayEventsUuids): string[] => {
        const eventsDates: string[] = [];

        if (
            !incompletedSprayEventsUuids ||
            !incompletedSprayEventsUuids.length
        ) {
            return [];
        }

        incompletedSprayEventsUuids.forEach((uuid) => {
            const startDate = get(sprayEvents, [uuid, 'startDate']);

            eventsDates.push(
                moment(startDate, 'YYYY-MM-DD').format('DD/MM/YYYY').toString()
            );
        });

        return uniq(eventsDates);
    }
);

const makeSelectSelectedSprayEventsDates = (): typeof selectSelectedSprayEventsDates =>
    selectSelectedSprayEventsDates;

export { selectSprayEventsUuids, makeSelectSelectedSprayEventsDates };
